import React from "react";
import styled from "styled-components";
import TextRenderer from "./TextRenderer";
import smallLogo from "../../Assets/Farazandishan-logo-2.png"
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../Loading";

const Style = styled.div`
    display: flex;
    position: relative;
    isolation: isolate;
    .bg-image {
        z-index: 1;
        position: absolute;
        inset: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .cover {
        z-index: 2;
        position: absolute;
        inset: 0;
        background-color: #00000088;
    }
    .data {
        z-index: 3;
        width: calc(100% - 140px);
        padding: 5rem 70px 5rem;
        gap: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: end;
        text-align: center;
        .title {
            font-size: 2rem;
            font-weight: 800;
            color: #fff;
        }
        .box {
            position: relative;
            background-color: #f5faff;
            box-shadow: var(--n-shadow-1);
            padding: 2rem;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .show-numbers {
                display: flex;
                justify-content: space-around;
                .company {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    .number {
                        font-size: 2rem;
                    }
                    .text {
                        font-size: 1.3rem;
                    }
                }
            }
        }
    }
    @media (max-width: 850px){
        .data { 
            justify-content: end;
            width: calc(100% - 32px);
            padding: 3rem 16px 3rem;
            .box {
                padding: 2rem 1rem;
            }
        }
    }
`;


const Company_query = gql`
    query CompanyQuery{
        getCompanyAndJobs {
            status
            data
            companycount
            jobscount
        }
    }
`



export default function CompanyAndJobs({pageHeight, data}) {
    const query = useQuery(Company_query);
    const makeAns = () => {
        if(query.loading){
            return (
                <Loading/>
            )
        }
        if(query.error){
            return (
                <div className="show-numbers">
                    <div className="company">
                        <div className="number">
                            {query.data.getCompanyAndJobs.companycount}
                        </div>
                        <div className="text">
                            0
                        </div>
                    </div>
                    <div className="company">
                        <div className="number">
                            {query.data.getCompanyAndJobs.jobscount}
                        </div>
                        <div className="text">
                            0
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="show-numbers">
                <div className="company">
                    <div className="number">
                        {query.data.getCompanyAndJobs.companycount}
                    </div>
                    <div className="text">
                        Company
                    </div>
                </div>
                <div className="company">
                    <div className="number">
                        {query.data.getCompanyAndJobs.jobscount}
                    </div>
                    <div className="text">
                        Jobs
                    </div>
                </div>
            </div>
        )
    }
    return (
      <Style>
        <div className="bg-image">
            <img src={data.data.bgimage} alt={data.title}/>
        </div>
        <div className="cover">
        </div>
        <div className="data">
            <div className="title">
                {data.data.title}
            </div>
            <div className="box">
                {makeAns()}
            </div>
        </div>
      </Style>
  );
}
